import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { FatcaModel } from '../model';
import { IFormStore } from '../interface';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: FatcaModel };

const initialState: State = { state: 'idle' };

@Injectable()
export class FatcaDeclarationStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<FatcaModel>((_, data) => ({ state: 'valid', data: FatcaModel.fromJson(data) }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));

  constructor() {
    super(initialState);
  }
}
